<template>
  <div class="list-value container-fluid">
    <div class="row">
      <button
        type="button"
        class="btn btn-primary btn-voltar"
        @click="$router.back()"
      >
        <font-awesome-icon :icon="'arrow-left'" />
        Voltar
      </button>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 page-header">
            <div class="col-xs-12 col-sm-10">
              <h2 class="small">
                {{ model.nome }}
                <!-- <small> {{ model.descricao }} </small> -->
              </h2>
            </div>
            <div class="col-xs-12 col-sm-2">
              <ul id="bandeiras">
                <li v-for="i in model.metas" :key="i.codigo">
                  <a
                    :href="i.link"
                    target="_blank"
                    :title="i.titulo"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-trigger="hover"
                    :data-content="i.objetivo"
                  >
                    <img :src="concatPathImage(i.imagem_url)" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <list
              ref="vuetable"
              :show-empty="true"
              :reportTitle="model.DAD_DCNOME + '-valores'"
              :append-params="params"
              api-url="dado/valor/list"
              title="Listagem de valores"
              :fields="columns"
              :pageCollection="'adminValues'"
            >
              <template slot="actions">
                <router-link
                  class="btn btn-default"
                  :to="{
                    name: 'admin_dado_valor_save',
                    DAD_IDDADO: params.DAD_IDDADO
                  }"
                >
                  <font-awesome-icon :icon="'plus'" /> Adicionar valor
                </router-link>
              </template>
              <template slot="rowrender" slot-scope="props">
                <div class="">
                  <router-link
                    class="btn btn-primary"
                    :to="{
                      name: 'admin_dado_valor_save',
                      params: {
                        DAD_IDDADO: params.DAD_IDDADO,
                        DVA_IDDADOVALOR: props.rowData.DVA_IDDADOVALOR
                      }
                    }"
                  >
                    <font-awesome-icon :icon="'edit'" />
                  </router-link>
                  <button
                    title="Excluir"
                    class="btn btn-danger"
                    @click="excluir(props.rowData)"
                  >
                    <font-awesome-icon :icon="'trash'" />
                  </button>
                </div>
              </template>
            </list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  name: 'dados-valor',
  data() {
    return {
      type: 'DADOVALOR',
      params: { DAD_IDDADO: 0 },
      columns: [
        {
          name: 'DVA_DTDADOVALOR',
          sortField: 'DVA_DTDADOVALOR',
          title: 'Data',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'USER',
          sortField: 'USER',
          title: 'Usuário',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'VALOR',
          sortField: 'VALOR',
          title: 'Valor',
          dataClass: 'align-middle',
          filterable: true,
          callback: value =>
            isNaN(value)
              ? value
              : new Intl.NumberFormat('pt-br', {
                  minimumFractionDigits: 2
                }).format(value)
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ],
      model: {
        DAD_DCNOME: '',
        DAD_DSDADO: '',
        DAD_DLFONTE: '',
        metas: []
      }
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    var me = this
    me.params = me.$router.history.current.params

    request
      .get(`dado/get/${me.params.DAD_IDDADO}`)
      .then(response => {
        me.model = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = this.type

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .post('dado/valor/delete', data)
            .then(() => {
              this.$toastr.s('Valor excluído com sucesso!')
              dt.refresh()
            })
            .catch(error => {
              console.log(error.response)
              this.$toastr.e(
                'Houve um error ao tentar excluir este item, por favor tente novamente mais tarde.'
              )
            })
        }
      }
      this.showConfirm('Deseja realmente deletar este item?', config)
    },
    concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime()
    }
  },
  updated() {
    window.jQuery('[data-toggle="popover"]').popover({})
  }
}
</script>

<style>
.list-value #bandeiras {
  list-style-type: none;
  padding-left: 0px;
  font-size: 0px;
}
.list-value #bandeiras > li {
  max-width: 50%;
  float: left;
}
.list-value #bandeiras > li > a > img {
  width: 100%;
}
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/values/index.vue